__turbopack_context__.v({
  "regionLink": "ddS3pW_regionLink",
  "regionsGrid": "ddS3pW_regionsGrid",
});
